import { Feedback } from '@/model/feedback';

export function getAdminInstantApprovalTemplate(): Feedback {
  return {
    appropriateContent: {
      isAppropriate: true,
      reason: 'Admin instant approval',
    },
    category: {
      isCorrect: true,
      newCategories: [],
      reason: 'Admin instant approval',
    },
    comprehensibleContent: {
      isComprehensible: true,
      reason: 'Admin instant approval',
    },
    type: {
      isCorrect: true,
      newType: '',
      reason: 'Admin instant approval',
    },
    link: {
      isCorrect: true,
      reason: 'Admin instant approval',
    },
    image: {
      isAppropriate: true,
      reason: 'Admin instant approval',
    },
    finalDecision: 'APPROVE',
    rejectionReason: '',
  };
}
